import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import PageviewIcon from "@mui/icons-material/Pageview";
import React from "react";
import { ICSDrawerContents } from "@ntg/component-library/declarations";

export const DrawerContents: ICSDrawerContents = {
    Items: [
        {
            DrawerItems: [
                {
                    Icon: <PageviewIcon color="primary" />,
                    PrimaryText: "Boat Types",
                    To: "/boatTypeSearch",
                    ShowMobile: true
                },
                {
                    Icon: <ManageSearchIcon color="primary" />,
                    PrimaryText: "Actual Boats",
                    To: "/actualBoatSearch",
                    ShowMobile: true
                },

            ],
            ShowTitle: false,
            Title: "Home"
        },
        {
            DrawerItems: [
                {
                    Icon: <FormatListBulletedIcon color="secondary" />,
                    PrimaryText: "Type/Model List",
                    To: "/admin / types"
                },
                {
                    Icon: <FormatListNumberedIcon color="secondary" />,
                    PrimaryText: "Type/Model Msm List",
                    To: "/admin / msm"
                },
                {
                    Icon: <CloseFullscreenIcon color="secondary" />,
                    PrimaryText: "Suggest Type/Model Consolidation",
                    To: "/admin / msm"
                },
                {
                    Icon: <CloseFullscreenIcon color="secondary" />,
                    PrimaryText: "Consolidate Type/Model",
                    To: "/admin / msm"
                },
                {
                    Icon: <CloseFullscreenIcon color="secondary" />,
                    PrimaryText: "Suggest Actual Boat Consolidation",
                    To: "/admin / msm"
                },
                {
                    Icon: <CloseFullscreenIcon color="secondary" />,
                    PrimaryText: "Consolidate Actual Boat",
                    To: "/admin / msm"
                },
            ],
            ShowTitle: true,
            Title: "Admin"
        }
    ]
};
